/*
 * Copyright (c) 2019 brightlamp
 */

const NotFound = () => import(/* webpackChunkName: "web" */ '@/views/not-found');

export default
[
    {
        path: '*',
        name: 'NotFound',
        component: NotFound,
        meta:
        {
            title: '404 (Page Not Found)'
        }
    }
]